export default __webpack_public_path__ + "assets/images/Alert-white-b4c3050ed06d765b4a5cdb93f9411cbf.svg";